// extracted by mini-css-extract-plugin
export default {"container":"AdminPage_container__ZeleY","link":"AdminPage_link__6cVMI"};